import React from "react"
import { useNavigate } from "react-router-dom"
import { Grid, Typography, Stack, Paper, Link } from "@mui/material"
import FormatQuoteIcon from "@mui/icons-material/FormatQuote"
import LockIcon from "@mui/icons-material/Lock"
import ContactPhoneIcon from "@mui/icons-material/ContactPhone"
import SchoolTwoToneIcon from "@mui/icons-material/SchoolTwoTone"
import { F_START_DATENSCHUTZ, F_START_IMPRESSUM } from "../../../constants/routes"

const Sidebar = () => {
  const navigate = useNavigate()

  return (
    <Grid item xs={12} md={4}>
      <Paper elevation={0} sx={{ p: 2, bgcolor: "grey.200" }}>
        <Typography variant="h6" gutterBottom>
          Individuelle Anpassungen
        </Typography>
        <Typography>
          Hat Ihre Schule Besonderheiten im Büchersystem? Haben Sie beispielsweise eine übergreifende Oberstufe? Kontaktieren Sie und für individuelle
          Module.
        </Typography>
      </Paper>
      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        Unsere Partner
      </Typography>
      {["Hans-und-Hilde-Coppi-Gymnasium", "George-Orwell-Oberschule", "Paul-und-Charlotte-Kniese-Schule", "Schule am Tierpark"].map((school) => (
        <Typography display="inline-flex" variant="body1" key={school}>
          <SchoolTwoToneIcon sx={{ mr: 1 }} /> {school}
        </Typography>
      ))}
      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        Impressum & Kontakt
      </Typography>
      {[
        { name: "Kontakt", icon: ContactPhoneIcon, id: "Kontakt", route: F_START_IMPRESSUM },
        { name: "Datenschutzerklärung", icon: LockIcon, id: "datenschutz", route: F_START_DATENSCHUTZ },
        { name: "Impressum", icon: FormatQuoteIcon, id: "impressum", route: F_START_IMPRESSUM },
      ].map((element) => (
        <Link display="block" variant="body1" href="#" onClick={() => navigate(element.route)} key={element.name} sx={{ mb: 0.5 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <element.icon sx={{ color: "start.hover" }} />
            <Typography sx={{ color: "start.hover" }}>{element.name}</Typography>
          </Stack>
        </Link>
      ))}
    </Grid>
  )
}

export default Sidebar
